<template>
<div class="bg-white">
    <div class="container first-element" style="padding-top: 62px;">

        <div class="clear-3"></div>
        <div class="container-small">

            <h1 class="h2 font-weight-bold headline-strong-1 text-blue">Impressum</h1>

            <div class="clear-1"></div>
            <h4 class="text-primary">Angaben gemäß § 5 TMG </h4>

            <div class="clear-1"></div>
            <p><strong>Anbieter dieser Website i.S.v. § 5 TMG ist die:</strong></p>
            <p>
                GSI - Gesellschaft für Schweißtechnik International mbH<br> Aachener Straße 172<br> 40223
                Düsseldorf
                <br> Tel.: +49 211 1 59 62 27<br> Fax: +49 203 3 78 13 08<br>
            </p>
            <p>
                E-Mail: sekretariat(at)gsi-slv.de
            </p>

            <div class="clear-1"></div>
            <p>
                <b>Geschäftsführer:</b><br> Dr.- Ing. Jörg Vogelsang
            </p>
            <p>
                Registergericht: Düsseldorf<br> Registernummer: HRB 377 19
            </p>
            <div class="clear-1"></div>
            <p>
                <b>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:</b><br> DE 813 013
                727
            </p>
            <p>
                Ein Unternehmen des DVS - Deutscher Verband für Schweißen und verwandte Verfahren e. V.
            </p>
            <div class="clear-1"></div>
            <p>
                <b>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV.:</b><br> Stabsstelle Öffentlichkeitsarbeit
                der GSI mbH<br> Dr.- Ing. Jörg Vogelsang
            </p>

            <div class="clear-1"></div>
            <p><b>Datenschutz</b><br> <a href="/datenschutzerklaerung" target="_blank">Datenschutzerklärung</a>
            </p>
            <div class="clear-1"></div>
            <p><b>Datenschutzbeauftragter gemäß BDSGKontaktdaten des
                    Datenschutzbeauftragten:</b><br>Herr Bernhard Pickert-Goldenbogen
                    <br> E-Mail: <a target="_blank" href="mailto:Datenschutz@gsi-slv.de">Datenschutz@gsi-slv.de</a>
            </p>
            <div class="clear-1"></div>
            <p><b>Grafische und technische Umsetzung</b><br> CMF Advertising GmbH<br>
                <a target="_blank" href="https://www.cmf.de">www.cmf.de</a>
            </p>
            <div class="clear-1"></div>
            <p class="m-0">
                <b>Ansprechpartner</b><br> Dr.- Ing. Jörg Vogelsang<br> Tel: +49 203 3781-119<br> E-Mail:
                sekretariat(at)gsi-slv.de
            </p>

            <div class="clear-3"></div>
        </div>
</div>

    </div>
</template>

<style lang="scss" scoped>
    @import 'resources/sass/_variables.scss';


    .clear-1 {
        height: 1rem;
    }

    .clear-2 {
        height: 2rem;
    }

    p {
        line-height: 1.2;
        margin: 0 0 10px;
    }

</style>

<script>
    export default {
        mounted() {

        }
    }

</script>
